import {
  GetSATProgramDetailsRequest,
  GetSATProgramDetailsResponse,
} from './OnboardingRequestTypes';

export type SATBootcampLastScores = {
  lastMathScore?: number;
  lastReadingWritingScore?: number;
};

export type SATBootcampProgramDetails = GetSATProgramDetailsRequest &
  GetSATProgramDetailsResponse &
  SATBootcampLastScores;

export enum BootcampEntryPoint {
  AP_RESULTS = 'APResults',
  AP_ONBOARDING = 'APOnboarding',
  INTRO = 'intro',
  COURSE_PICKER = 'coursePicker',
  FOLLOW_COURSE_HOME = 'followCourseHome',
  FOLLOW_COURSE_PROFILE = 'followCourseProfile',
  SAT_BOOTCAMP_INTRO = 'SATBootcampIntro',
  AP_BOOTCAMP_INTRO = 'APBootcampIntro',
  UNCLAIMED_ENTITLEMENT = 'unclaimedEntitlement',
  LOCKED_AP_COURSE = 'lockedAPCourse',
  COURSE_PROFILE = 'courseProfile',
  ADDITIONAL_DETAIL_PROMPT = 'additionalDetailPrompt',
  SAT_FREE_ACCESS_ENDED = 'SATFreeAccessEnded',
  SAT_FREE_ACCESS_PROMO = 'SATFreeAccessPromo',
}

export type SATExamCountdownDuration = {
  duration: moment.Duration;
  isExpired: boolean;
};

export type SATExamDateTime = {
  dateTime: moment.Moment;
};

export enum OnboardingContainerEntryPoint {
  INTRO_VIDEO = 'introVideo',
  EXAM_SELECTION = 'examSelection',
}

export enum SATClaimedAccessType {
  PAID = 'paid',
  FREE = 'free',
}
